import * as React from "react";

import "./ml-table.scss";

import {cs}                      from "@Common/react/chain-services";
import {consumeContext}          from "@Common/react/context";
import {UseState}                from "@Common/react/use-state";
import {DataTableD1}             from "@Common/ui-components/heavy/common/design2/data-table/data-table-d1";
import {getPageSummary}          from "@Common/ui-components/heavy/common/design2/data-table/get-page-summary";
import {PageList}                from "@Common/ui-components/heavy/common/design2/pagination-ui/page-list/page-list";
import {PageSize, PAGE_SIZE_ALL} from "@Common/ui-components/heavy/common/design2/pagination-ui/page-size/page-size";
import {EditMailingListModal}    from "@Common/ui-components/heavy/mailing-ui/ml-list-table/edit-mailing-list-modal/edit-mailing-list-modal";
import {mlContentColumns}        from "@Common/ui-components/heavy/mailing-ui/ml-list-table/ml-content-columns";
import {mlContentDataColumns}    from "@Common/ui-components/heavy/mailing-ui/ml-list-table/ml-content-data-columns";

import {DownloadMailingList}     from "../download-mailing-list";

export const MlTable = ({entityId = undefined, mailingLists}) => cs(
    consumeContext("apis"),
    ["editMailingListModal", (_, next) => EditMailingListModal({entityId, next})],
    ["pageSize", (_, next) => UseState({next, getInitValue: () => 10})],
    ({}, next) => (
        <div className="ml-table ml-table-8dv">
            {next()}
        </div>
    ),
    ["downloadMailingList", ({}, next) => DownloadMailingList({
        next,
    })],
    ({apis, pageSize, editMailingListModal, downloadMailingList}) => DataTableD1({
        getDefaultSorting: () => ({
            columnIndex: 3, // Order by newest date created
            direction: "desc",
        }),
        columns: mlContentColumns({
            showSource: true,
        }),
        pageSize: pageSize.value,
        rows: mailingLists.value?.map((ml) => ({
            key: ml.id,
            columns: mlContentDataColumns({
                showSource: true,
                ml,
                onEdit: (ml) => {
                    editMailingListModal.show({
                        ml,
                        onChangeCount: () => mailingLists.reload(),
                    });
                },
                onRemove: async () => {
                    await apis.next.mailing.deleteMailingList({id: ml.id, entityId});
                    mailingLists.change((_) => _.filter((ml1) => ml1.id !== ml.id));
                },
            }),
            xdQaName: ml.mailingListName,
        })),

        getFooter: ({pagination, colCount}) => mailingLists.value?.length > 10 && {
            // className: "paging-control",
            // color: "light",
            columns: [{
                colSpan: colCount,
                render: () => (
                    <div className="controls">
                        {PageSize({
                            state: pageSize,
                            extraSizes: [PAGE_SIZE_ALL],
                        })}

                        {pagination.active && <>
                            <div className="pagination">
                                {PageList(pagination)}
                            </div>

                            {getPageSummary({
                                pageIndex: pagination.state.value,
                                pageSize: pageSize.value,
                                count: mailingLists.value?.length
                            })}
                        </>}
                    </div>
                ),
            }],
        },
    }),
);
